"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_reanimated_carousel_1 = __importDefault(require("react-native-reanimated-carousel"));
const S = __importStar(require("./SliderCarousel.styles"));
const Atoms_1 = require("../../Atoms");
exports.default = ({ data }) => {
    const [sliderActiveSlide, setSliderActiveSlide] = react_1.useState(1);
    const loadImages = ({ item }) => {
        return (react_1.default.createElement(S.Image, { accessible: true, source: { uri: item.image }, accessibilityLabel: item.accessibilityLabel, accessibilityHint: item.accessibilityLabel }));
    };
    // Calculate the number of bullets according to the data length
    const bullets = [];
    for (let index = 1; index <= data.length; index += 1) {
        bullets.push(react_1.default.createElement(S.Dot, { active: sliderActiveSlide === index }));
    }
    return (react_1.default.createElement(S.scrollbarContainer, null, data.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_reanimated_carousel_1.default, { data: data, renderItem: loadImages, width: 350, height: 350, autoPlay: false, pagingEnabled: true, loop: true, snapEnabled: true, onSnapToItem: (index) => setSliderActiveSlide(index + 1) }),
        react_1.default.createElement(S.DotView, null,
            react_1.default.createElement(S.BulletContainer, null, bullets)))) : (react_1.default.createElement(Atoms_1.Text, null, "No images to show."))));
};
